import React, { useState, useEffect } from 'react'
import WebService from '../../api/explus-api'
import swal from "sweetalert2";
import EmojiRating  from './form/EmojiRating';
import { get_fiscal_year } from '../helpers/utilities';
import '../../assets/css/modal.css'//2022

const styles = {
  link: {
    background: 'transparent',
    color: '#f60',
    padding: '0',
    border: '2px solid red'
  },

  cuvbtn: {
    background: 'transparent',
    color: '#f60',
    padding: '0',
    borderColor: '#FF6600',
    padding: '2px 18px',
    borderRadius: '0',
    textDecoration: 'none'
  }
}

const initial_colors = {
  rating_1 : "LightGray",
  rating_2 : "LightGray",
  rating_3 : "LightGray",
  rating_4 : "LightGray",
  rating_5 : "LightGray",
}

const rating_colors = {
  1 : "Red",
  2 : "Orange",
  3 : "DimGray",
  4 : "LimeGreen",
  5 : "DarkGreen",    
}

const icon_size = 40;

const Modal = props => {
  const initial_store = {
    rating: "",
    type: props.rating_type,
    target: props.rating_target,
    fiscal_year: get_fiscal_year(),
    comment: "",
    meta: props.rating_meta
  };

  const [store, setStore] = useState(initial_store);
  const [icon_color, setColor] = useState(initial_colors);

  const clear = () => {
    setStore({ ...initial_store });
    setColor({ ...initial_colors });
  };

  function handleSave(){
    WebService.saveRating(store).then(data => {
      let message = '';

      if(data.success){
        message = '<p>'+data.success+'</p>';

        swal.fire("Success", message, "success");
        
        clear();
      }

      if(data.error){
        const responsew = data.error;

        message = '<p>'+data.error+'</p>';

        if ( typeof data.error === 'object' && !Array.isArray(data.error) && data.error !== null) {

            message = '';
            for (const [key, value] of Object.entries(data.error)) {
              message += '<p>'+value[0]+'</p>';
            }
        }

        
        swal.fire("Error", message, "error");
      }
    });
  }

  function handleRating(e){
    const { value } = e.currentTarget;
    let new_colors = { ...initial_colors };

    new_colors['rating' + '_' + value] = rating_colors[value];

    setStore({ ...store, rating : value });
    setColor(new_colors)
  }

  function handleChange(e){
    const { name, value } = e.target;
    setStore({ ...store, [name]: value });
  }

  if (props.content === '') {return <span></span>}
  let content = ''
  let el = ''

  let modal_head = 'myModal'
  
  if (props.el === 'link') {
    el = <button id="btn_watch_cuv" type="button" className="btn btn-sm" data-toggle="modal" data-target="#myModal">
      <i className="fab fa-youtube"></i> Watch Video
    </button>
  }
  // else if (props.el === 'cuv') {
  //   modal_head = 'myModal_cuv'
  //   // el = <button id="watch_cuv" style={styles.cuvbtn} type="button" className="btn btn-link btn-sm" data-toggle="modal" data-target="#myModal_cuv">
  //   //   <i className="fab fa-youtube"></i> Watch Update Video of <br/>My Sponsored Child
  //   // </button>
  //   /** Updated */
  //   el = <button id="btn_watch_cuv" type="button" className="btn btn-sm" data-toggle="modal" data-target="#myModal_cuv">
  //   <i className="fab fa-youtube"></i> Watch Update Video of <br/>My Sponsored Child
  // </button>
  // }
  else if (props.el === 'community_video') {
    modal_head = 'myModal2'
    el = <button id="btn_watch_yuv" stype="button" className="btn btn-sm" data-toggle="modal" data-target="#myModal2">
      <i className="fab fa-youtube"></i> Watch Video
    </button>
  }
  else if (props.el === 'share_link') {//2022
    modal_head = 'sharelinkModal'
    el = <button id="btn_share_link" stype="button" className="btn btn-sm" data-toggle="modal" data-target="#sharelinkModal" style={{marginTop: '10px'}}>
      <i className="fa fa-share" style={{marginRight: '5px'}}></i> Share
    </button>
  }
  // else {
  //   el = <button id="btn_watch_video" type="button" className="btn btn-sm" data-toggle="modal" data-target="#myModal">
  //         <i className="fab fa-youtube"></i> Watch Video
  //       </button>
  // }

  if (props.type === 'video') {
    content = <div> 
                <iframe title="wv-adp-video" style={{width: '100%'}} width="854" height="480" src={props.content} frameBorder="0" gesture="media" allow="encrypted-media" allowFullScreen></iframe>
                {/* Rating Secttion */}
                <h3 style={{ textAlign: 'left', marginBottom: '20px' }}>What do you think about the video?</h3>
                <EmojiRating handleRating={handleRating} icon_color={icon_color} icon_size={icon_size} />
                <textarea style={{ width: '100%', marginTop: '20px', marginBottom: '20px' }} placeholder='Your comments here' name='comment' onChange={handleChange} value={store.comment}></textarea>
                <button className='btn btn-lg' type='button' onClick={handleSave}>Save Rating</button>
              </div>
              // content = <iframe title="wv-adp-video" style={{width: '100%'}} width="854" height="480" src="https://www.youtube.com/embed/W9-WBxpdGlM" frameBorder="0" gesture="media" allow="encrypted-media" allowFullScreen></iframe>
  }

  if (props.type === 'cuv') {
    // modal_head = 'myModal2'
    // content = <iframe title="wv-adp-video" style={{width: '100%'}} width="854" height="480" src={props.content} frameBorder="0" gesture="media" allow="encrypted-media" allowFullScreen></iframe>
    //2022 updated
    content = <div> 
                <iframe title="wv-adp-video" style={{width: '100%'}} width="854" height="480" src={props.content} frameBorder="0" gesture="media" allow="encrypted-media" allowFullScreen></iframe>
                {/* Rating Secttion */}
                <h3 style={{ textAlign: 'left', marginBottom: '20px' }}>What do you think about the video?</h3>
                <EmojiRating handleRating={handleRating} icon_color={icon_color} icon_size={icon_size} />
                <textarea style={{ width: '100%', marginTop: '20px', marginBottom: '20px' }} placeholder='Your comments here' name='comment' onChange={handleChange} value={store.comment}></textarea>
                <button className='btn btn-lg' type='button' onClick={handleSave}>Save Rating</button>
              </div>
  }

  if (props.type === 'link') {
    //2022
    content = <div>
                  {/* <h4 className='mb-5 mt-5'>To protect every child's privacy, only include FIRST NAME and no other information when sharing this video.</h4> */}
                  <h4 className='mb-5 mt-5'>To protect every child's privacy, only include first name when sharing this video (no other information).</h4>
                  

                  <div className="input-groups mb-3">
                    <input type="text" className="form-control" placeholder="Video Link" aria-label="Recipient's username" value={props.content} onChange={handleChange} />
                    <div className="input-group-append">
                      <button className="btn btn-outline-secondary" type="button" onClick={() => {navigator.clipboard.writeText(props.content)}}><i className="fa fa-clipboard" style={{marginRight: '10px'}}></i>Copy</button>
                    </div>
                  </div>
              </div>
  }

  if (props.type === 'text') {
    content = props.content
  }

  let modal =<div className="modal fade" id={modal_head} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div className="modal-dialog" role="document">
    <div className="modal-content">
      {/* <div className="modal-header">
        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div> */}
      <div className="modal-body">
        {content}
      </div>
      <div className="modal-footer">
        <button type="button" className="btn" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

  return (
    <div className="modal-comp">

      {el}

      {modal}

    </div>
  )
}

export default Modal
